import { render } from "./employee-settings.vue?vue&type=template&id=35d6b140"
import script from "./employee-settings.vue?vue&type=script&lang=js"
export * from "./employee-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__